module.exports = __webpack_public_path__ + "static/media/pay_bills.701830dd.svg";